import { cn } from '@/util/cn';
import { IWithChildren } from '@/util/reactTypes';
import { useNoHeader } from '@/util/useNoHeader';

// Decorative mountain band between resort/region page content and the
// Footer. SVG sits flush with the container bottom so its bottom solid
// strip blends into the Footer's dark band. No background fill — the
// SVG paints over whatever page background is underneath.
const innerClass = 'h-[121px] bg-bottom bg-repeat-x';

export const BottomMountains = (
  { className, isOnSummerOverview }: Partial<IWithChildren> & { className?: string, isOnSummerOverview?: boolean },
) => {
  const { noHeader } = useNoHeader();
  if (noHeader) {
    return null;
  }

  const innerStyle = {
    backgroundImage: `url(${isOnSummerOverview
      ? '/assets/resort/green-mountains.svg'
      : '/assets/resort/blue-mountains.svg'})`,
  };

  return (
    <div className={cn(className)}>
      <div className={innerClass} style={innerStyle} />
    </div>
  );
};
